import React from 'react';

import InputSelectDropdown from 'components/InputSelectDropdown/InputSelectDropdown';

import { IOfferDesignOption } from '../hooks/useOfferDesignOptions';

interface IOfferDesignSelectorProps {
  options: IOfferDesignOption[];
  selectedValue: string;
  onChange: (value: string) => void;
  listDataTestId: string;
  buttonDataTestId?: string;
  dataTestId?: string;
  descriptionDataTestId?: string;
  description?: string;
  placeholder?: string;
}

/**
 * Shared offer design dropdown selector used across all offer forms.
 *
 * @example
 * <OfferDesignSelector
 *   options={offerDesignOptions}
 *   selectedValue={values.offerUiId}
 *   onChange={(value) => {
 *     setCurrentOfferUI(value);
 *     setFieldValue('offerUiId', value);
 *   }}
 *   listDataTestId="dashBundlesOfferDesignList"
 *   dataTestId="offerUiId"
 * />
 */
export const OfferDesignSelector: React.FC<IOfferDesignSelectorProps> = ({
  options,
  selectedValue,
  onChange,
  listDataTestId,
  buttonDataTestId,
  dataTestId,
  descriptionDataTestId,
  description,
  placeholder = 'Select Offer Design'
}): React.ReactElement => {
  const selectedOption = options.find((item) => item.value === selectedValue);

  return (
    <InputSelectDropdown
      label="Offer Design"
      isRequired
      placeholder={placeholder}
      listDataTestId={listDataTestId}
      buttonDataTestId={buttonDataTestId}
      dataTestId={dataTestId}
      descriptionDataTestId={descriptionDataTestId}
      options={options}
      defaultSelected={selectedOption}
      onOptionChange={onChange}
      description={description}
    />
  );
};
